export const MATRIX_FAVORITES = {
  BASE: 'api/matrix-favorites',
  BY_DASHBOARD: (dashboardId: number) => `${MATRIX_FAVORITES.BASE}/by-dashboard/${dashboardId}`,
  BY_USERNAME: () => `${MATRIX_FAVORITES.BASE}/by-username`,
};

export const DASHBOARD_DATA = {
  BASE: 'api/dashboard',
  TRACKER_CHART_DATA: () => `${DASHBOARD_DATA.BASE}/variance-tracker`,
  MATRIX_ANALYTICS: () => `${DASHBOARD_DATA.BASE}/analytics`,
  EMPLOYEE_INVESTIGATION: () => `${DASHBOARD_DATA.BASE}/employee-investigation`,
};

export const CASE_INVESTIGATION = {
  BASE: 'api/case-investigation',
};

export const EMPLOYEE_VARIANCE_MANAGEMENT = {
  BASE: 'api/employee-variance-management',
  CREATE_CASE_INVESTIGATION: () => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/case-investigation`,
  CREATE_CASE_INVESTIGATIONS: () => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/case-investigations`,
  GET_BY_ID: (id: number) => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/case-investigation/${id}`,
  UPDATE: (id: number) => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/case-investigation/${id}`,
  STATUS_LOGS: (caseId: number) => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/case-investigation/${caseId}/status-logs`,
  USERS: () => `${EMPLOYEE_VARIANCE_MANAGEMENT.BASE}/users`,
};

export const TIMELINE_EVENTS = {
  BASE: 'api/timeline-events',
  BY_CASE_ID: (caseId: number) => `${TIMELINE_EVENTS.BASE}/${caseId}`,
};

export const EMAIL_PREVIEW = {
  PREVIEW: () => 'api/email/preview',
};

export const EMAIL = {
  SEND: () => 'api/email/send',
};

export const EMAIL_ANALYTICS = {
  BASE: 'api/email-analytics',
  CHARTS: (incidentId: string) => `${EMAIL_ANALYTICS.BASE}/charts/${incidentId}`,
};

export const EMAIL_RESPONSE = {
  BASE: 'api/email-responses',
  BY_GUID: (guid: string) => `${EMAIL_RESPONSE.BASE}/${guid}`,
};

export const EMAIL_RESOLUTION_RESPONSES = {
  BASE: 'api/email-resolution-responses',
};

export const INCIDENTS = {
  BASE: 'api/incidents',
  BY_ID: (incidentId: string | number) => `api/incidents/${incidentId}`,
  TRANSACTIONS: (incidentNumber: string | number) => `api/incidents/${incidentNumber}/transactions`,
  STATUS_LOGS: (incidentId: string | number) => `api/incidents/${incidentId}/status-logs`,
  UPDATE: (incidentId: string | number) => `api/incidents/${incidentId}`,
};

export const FILTERS = {
  BASE: 'api/filters',
};

export const COMMENTS = {
  BASE: 'api/comments',
  THREAD: 'api/comments/thread',
};
